import { FC, memo, useEffect, useMemo, useState } from 'react'
import { AB_KEY, AB_VARIANT_VERSION } from '../../../common/constants'
import { useTranslation } from '../../../hooks/locale'
import { useABVariant } from '../../../utils/hooks'
import { SharedRotatingIndex } from '../../../utils/shared-rotating-index'
import { getBannerTags } from './tags'
import { BannerWrapper, BannerRow, BannerIcon, TextGroup, Heading, SubHeading } from './styles'

const TAG_ROTATION_INTERVAL = 3000

// One interval shared by every banner instance, so extra mounts cost nothing.
const sharedRotatingIndex = new SharedRotatingIndex(TAG_ROTATION_INTERVAL)

type Props = {
    traumTagIds: number[]
}

const TraumTagBanner: FC<Props> = ({ traumTagIds }) => {
    const { t } = useTranslation()
    const { isProvidedVariantActive } = useABVariant(AB_KEY.TAGS_PDP, AB_VARIANT_VERSION.ONE)

    const tags = useMemo(() => getBannerTags(traumTagIds), [traumTagIds])
    const [rotatingIndex, setRotatingIndex] = useState(() => sharedRotatingIndex.getCurrentIndex())

    useEffect(() => {
        // A single tag never changes, so there is nothing to subscribe to.
        if (tags.length <= 1) {
            return
        }

        return sharedRotatingIndex.subscribe(setRotatingIndex)
    }, [tags.length])

    if (!isProvidedVariantActive || tags.length === 0) {
        return null
    }

    const tag = tags[rotatingIndex % tags.length]

    return (
        <BannerWrapper>
            <BannerRow>
                <BannerIcon src={tag.iconSrc} alt="" />
                <TextGroup>
                    <Heading>{t(`${tag.translationKey}.title`)}</Heading>
                    <SubHeading>{t(`${tag.translationKey}.description`)}</SubHeading>
                </TextGroup>
            </BannerRow>
        </BannerWrapper>
    )
}

export default memo(TraumTagBanner)
